module.exports = __webpack_public_path__ + "img/PTS_BDOMA.6b91a3cc.gif";